/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Setpoints_Supply_Air_Temperature_HelpInputs */



/**
* | output |
* | --- |
* | "Temperature control by supply air temperature setpoint." |
*
* @param {Air_Handler_Unit_Setpoints_Supply_Air_Temperature_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_setpoints_supply_air_temperature_help = /** @type {((inputs?: Air_Handler_Unit_Setpoints_Supply_Air_Temperature_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Setpoints_Supply_Air_Temperature_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Temperature control by supply air temperature setpoint.")
	return /** @type {LocalizedString} */ ("Contrôle de la température par consigne de température de soufflage.")
});